var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H2V16H14V7H7V0Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0V5H14L9 0Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon2);
export default __webpack_public_path__ + "static/media/fileIcon2.1cbcd1a4d13a40156c67252a9849c6f9.svg";
export { ForwardRef as ReactComponent };